
  $(document).ready(function () {
    setTimeout(() => {
      // Attach event listener for radio input changes
      $('.rc-template__radio input').on('change', function() {
        handleRadioChange($(this)); 
      });

      // Handle initial price calculation on page load
      updatePriceAndSellingPlan(); 

    }, 700);

    // Attach event listener for variant changes
    $('.variant-swatches input').on('change', function() {
      setTimeout(() => {
        handleVariantChange($(this)); 
      }, 30);
    });
  });

  // Function to update price and selling plan based on the selected radio and variant
  function updatePriceAndSellingPlan() {
    var label = getActiveRadioLabel(); 
    var cleanedLabelText = cleanLabelText(label);
    var selectedValue = $('.variant-swatches input:checked').val();
    var numberOfBottles = getNumberOfBottles(selectedValue);
    var currentPrice = extractPrice(cleanedLabelText);
    var pricePerUnit = calculatePricePerUnit(currentPrice, numberOfBottles);

    if (cleanedLabelText) {
      updatePriceDisplay(pricePerUnit);
      updateSellingPlan(numberOfBottles);
    }

    console.log('Price per unit:', pricePerUnit);
  }

  // Handle the radio button change event
  function handleRadioChange(radioInput) {
    $('.rc-template__radio .rc-radio').removeClass('rc-radio--active');
    radioInput.closest('.rc-radio').addClass('rc-radio--active');
    updatePriceAndSellingPlan(); // Update price and selling plan
  }

  // Handle the variant change event
  function handleVariantChange(variantInput) {
    updatePriceAndSellingPlan(); // Update price and selling plan
  }

  // Get the active radio label text
  function getActiveRadioLabel() {
    return $('.rc-radio--active .rc-radio__label').text().trim();
  }

  // Clean the label text to remove unnecessary words
  function cleanLabelText(text) {
    return text.replace("One-time purchase", "")
               .replace("Subscribe & save 10%", "")
               .replace("Subscribe & save 20%", "")
               .replace("Subscribe & save 15%", "")
               .replace(/Subscribe & save \d{1,3}(\.\d+)?%/, "")
               .trim();
  }

  // Extract the number of bottles from the input value
  function getNumberOfBottles(value) {
    return parseInt(value.match(/\d+/)[0]);
  }

  // Extract the numeric price from the cleaned text
  function extractPrice(trimmedText) {
    return parseFloat(trimmedText.replace(/[^\d.-]/g, ''));
  }

  // Calculate the price per unit
  function calculatePricePerUnit(currentPrice, numberOfBottles) {
    return (currentPrice / numberOfBottles).toFixed(2);
  }

  // Update the price display on the page
  function updatePriceDisplay(pricePerUnit) {
    $('.main-price .price-item--sale').text('$' + pricePerUnit + '/unit');
  }

  // Update the selling plan based on the number of bottles
  function updateSellingPlan(numberOfBottles) {
    var selectBox = $('.rc-selling-plans-dropdown__select');  // Use class selector
    var option30Days = selectBox.find('option').eq(0).val();  // First option (30 Days)
    var option90Days = selectBox.find('option').eq(1).val();  // Second option (90 Days)
    var option180Days = selectBox.find('option').eq(2).val(); // Third option (180 Days)

    var sellingPlanValue;

    if (numberOfBottles === 1) {
      sellingPlanValue = option30Days;
    } else if (numberOfBottles === 3) {
      sellingPlanValue = option90Days;
    } else if (numberOfBottles === 6) {
      sellingPlanValue = option180Days;
    }

    // Update the select dropdown and trigger events
    selectBox.val(sellingPlanValue);
    selectBox[0].dispatchEvent(new Event('input', { bubbles: true }));
    selectBox[0].dispatchEvent(new Event('change', { bubbles: true }));

    // Update the URL parameter for selling_plan
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('selling_plan', sellingPlanValue);
    window.history.replaceState(null, '', currentUrl.toString());

    console.log('Selling plan updated to:', sellingPlanValue);
  }

